import { useState} from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleDown } from "@fortawesome/free-solid-svg-icons";
import useAuthStore from "../../../store/AuthStore";
import Dropdown from "../../Dropdown";
import MicroProfile from "../../user/MicroProfile";
import SidebarMobile from "./MobileSidebar";
import SidebarDesktop from "./DesktopSidebar";

const Sidebar = ({ sidebarLinks, toggleMenu, menuStatus, profileTitle }) => {
  const { pathname } = useLocation();
  const [toggleDropDown, setToggleDropDown] = useState(false);
  const [myIndex, setMyIndex] = useState();
  const { user } = useAuthStore();
  const handleToggle = (index) => {
    if (index !== myIndex) {
      setToggleDropDown(true);
      setMyIndex(index);
      return;
    }
    if (!index) return;
    setMyIndex(index);
    setToggleDropDown(!toggleDropDown);
  };

  const links = sidebarLinks.map((link, index) => {
    return (
    <li
      onClick={() => handleToggle(index)}
      key={link.name}
      className={`w-full rounded-lg transition-all duration-200 overflow-hidden shadow-sm capitalize${
        pathname.endsWith(link.url) || pathname.includes(link.name.toLowerCase())
          ? "bg-yellow-700/10 text-yellow-400 ring-2 ring-yellow-400"
          : "text-gray-300 hover:bg-gray-700/60 hover:text-white"
      }`}
    >
      <Link to={link.url}>
        <span
          onClick={link.subLinks ? null : toggleMenu}
          className="flex items-center justify-between w-full px-4 py-2 text-lg font-medium"
        >
          <div className="flex gap-4 items-center">
            <FontAwesomeIcon icon={link.icon} className="text-xl" />
            {link.name}
          </div>
          {link.subLinks && (
            <FontAwesomeIcon
              icon={faArrowCircleDown}
              size="sm"
              className="transition-transform duration-300"
            />
          )}
        </span>
      </Link>
      {link.subLinks && (
        <Dropdown
          toggleSideBar={toggleMenu}
          toggle={toggleDropDown}
          index={index}
          myIndex={myIndex}
          dropdownLinks={link.subLinks}
        />
      )}
    </li>
  )});

  return (
    <aside
      className={`pt-0 overflow-y-auto overflow-x-hidden fixed top-[50px] left-0 md:sticky max-w-[50%] min-w-[250px] md-left-0 h-full z-20 ${
        menuStatus ? "block" : "hidden"
      } md:block`}
    >
      <SidebarMobile
        links={links}
        menuStatus={menuStatus}
      />
      <SidebarDesktop
        links={links}
        children={<MicroProfile username={user?.username || profileTitle} />}
      />
    </aside>
  );
};

export default Sidebar;
